// Interface for MMR vaccination data structu
import { ExemptionData } from "./types";
import { loadAllExemptionData } from "./loadExemptionData";

// Export exemption data variable
export let exemptionData: ExemptionData = {};

// Function to load the exemption data
export async function loadExemptionData(): Promise<ExemptionData> {
  try {
    exemptionData = await loadAllExemptionData();
    return exemptionData;
  } catch (error) {
    console.error("Error loading exemption data:", error);
    return exemptionData;
  }
}

// Load the data immediately when this module is imported
loadExemptionData().catch((error) => {
  console.error("Failed to preload exemption data:", error);
});
